// Class
import { SmartTagBase } from './smartTagBase';
// Model
import { SmartTagModel } from './smartTag.model';

export class SmartTagPoolTypeModel extends SmartTagModel {
	poolType?: any[];

	constructor() {
		super();
		this.poolType = [];
	}
}

export class SmartTagPoolType extends SmartTagBase {

	/**
	 * Renderer
	 * @param data SmartTagUpdateModel
	 */
	public render(data: SmartTagPoolTypeModel, version?: string): string {
		this.getData(data);

		return this.getOutputData(version || 'v1');
	}

	private getData(data: SmartTagPoolTypeModel): void{
		const title = data.title || data.subCategory || '';
		const poolTypes = data.poolType || [];
		const description = data.description?.trim() || '';

		if (title !== '') {
			this.title = `<span title="${title}">Type: ${title}</span>`;
		}

		if (poolTypes && poolTypes.length > 0) {
			this.addText(`<span title="Pool Type:">Pool Type:</span>`);
			poolTypes.forEach((poolType: any) => {
				this.addText(`<span title="${poolType.typeName}">&nbsp;&nbsp;&nbsp;&nbsp;${poolType.typeName}</span>`);
			});
		}

		if (description !== '') {
			this.addText(`<span title="${description}">Description: ${description}</span>`);
		}
	}
}
